import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useSetUserOnboardedMutation as UseSetUserOnboardedMutation,
  type useSetUserOnboardedMutation$data
} from '@/__generated__/useSetUserOnboardedMutation.graphql'

type CommitAsyncFn = () => Promise<useSetUserOnboardedMutation$data>

export const useSetUserOnboardedMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseSetUserOnboardedMutation>(graphql`
    mutation useSetUserOnboardedMutation($input: SetUserOnboardedInput!) {
      setUserOnboarded(input: $input) {
        clientMutationId
        user {
          onboardedAt
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useSetUserOnboardedMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              clientMutationId: 'setUserOnboarded'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
